import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { WHATSAPP_RESULT_ASSISTANCE } from 'Constants/whatsappLinks';
import { openUrlInNewNavigator } from 'Utils/links';

const ChatBoxButton = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <Buttons.Tiny
      label={t('Result.ChatBoxButton.CTA')}
      onClick={() => openUrlInNewNavigator(WHATSAPP_RESULT_ASSISTANCE)}
    />
  );
};

export default ChatBoxButton;
